import axios from "../../helpers/axios"
import { architectLiConstants } from "../constants"

export const getArchitectLi = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: architectLiConstants.GET_ARCHITECT_LI_REQUEST })
            const res = await axios.get("architectLi/get")
            if (res.status === 200) {
                const { architectLi } = res.data
                dispatch({
                    type: architectLiConstants.GET_ARCHITECT_LI_SUCCESS,
                    payload: {
                        architectLi
                    }
                })
            } else {
                dispatch({ type: architectLiConstants.GET_ARCHITECT_LI_FAILURE })
            }
        } catch (e) {
            console.log(e)
        }
    }
}


